import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-4 h-4" />
          </Button>
          <h1 className="text-xl font-bold text-gray-900">Personvernerklæring</h1>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-sm p-6 md:p-8 prose prose-gray max-w-none">
          <p className="text-sm text-gray-500 mb-6">Sist oppdatert: Januar 2026</p>

          <h2>1. Introduksjon</h2>
          <p>
            GolfMarked ("vi", "oss", "vår") respekterer ditt personvern og er forpliktet til å 
            beskytte dine personopplysninger. Denne personvernerklæringen forklarer hvordan vi 
            samler inn, bruker og beskytter informasjonen din når du bruker vår markedsplass 
            for brukt golfutstyr.
          </p>

          <h2>2. Informasjon vi samler inn</h2>
          <h3>2.1 Informasjon du gir oss</h3>
          <ul>
            <li><strong>Kontoinformasjon:</strong> Navn, e-postadresse når du registrerer deg</li>
            <li><strong>Annonseinformasjon:</strong> Tittel, beskrivelse, bilder, pris, kontaktinformasjon (navn, e-post, telefon)</li>
            <li><strong>Meldinger:</strong> Innhold i meldinger sendt gjennom plattformen</li>
            <li><strong>Google-innlogging:</strong> Hvis du logger inn med Google, mottar vi navn, e-post og profilbilde</li>
          </ul>

          <h3>2.2 Automatisk innsamlet informasjon</h3>
          <ul>
            <li>Visningsstatistikk for annonser</li>
            <li>Teknisk informasjon for feilsøking</li>
          </ul>

          <h2>3. Hvordan vi bruker informasjonen</h2>
          <p>Vi bruker informasjonen din til å:</p>
          <ul>
            <li>Vise dine annonser til potensielle kjøpere</li>
            <li>Tilrettelegge kommunikasjon mellom kjøpere og selgere</li>
            <li>Administrere din brukerkonto</li>
            <li>Forbedre og vedlikeholde tjenesten</li>
            <li>Forhindre svindel og misbruk</li>
          </ul>

          <h2>4. Deling av informasjon</h2>
          <p>
            Vi selger ikke dine personopplysninger. Informasjon deles kun:
          </p>
          <ul>
            <li>Med andre brukere når du publiserer en annonse (kontaktinfo vises)</li>
            <li>Med tjenesteleverandører som hjelper oss å drifte plattformen (hosting, bildeopplasting)</li>
            <li>Når loven krever det</li>
          </ul>

          <h2>5. Datalagring</h2>
          <p>
            Dine data lagres så lenge du har en aktiv konto eller aktive annonser. 
            Slettede annonser fjernes fra databasen. Du kan be om sletting av kontoen din 
            ved å kontakte oss.
          </p>

          <h2>6. Dine rettigheter (GDPR)</h2>
          <p>Du har rett til å:</p>
          <ul>
            <li><strong>Få innsyn:</strong> Be om kopi av dine personopplysninger</li>
            <li><strong>Rette:</strong> Korrigere unøyaktige opplysninger</li>
            <li><strong>Slette:</strong> Be om sletting av dine data</li>
            <li><strong>Begrense:</strong> Begrense behandlingen av dine data</li>
            <li><strong>Portabilitet:</strong> Motta dine data i et strukturert format</li>
            <li><strong>Protestere:</strong> Protestere mot behandling av dine data</li>
          </ul>

          <h2>7. Informasjonskapsler (Cookies)</h2>
          <p>
            Vi bruker nødvendige informasjonskapsler for å holde deg innlogget. 
            Vi bruker ikke sporings- eller markedsføringscookies.
          </p>

          <h2>8. Sikkerhet</h2>
          <p>
            Vi bruker bransjestandarder for å beskytte dine data, inkludert:
          </p>
          <ul>
            <li>Kryptert overføring (HTTPS)</li>
            <li>Sikker passordhashing (bcrypt)</li>
            <li>Begrenset tilgang til data</li>
          </ul>

          <h2>9. Barn</h2>
          <p>
            Tjenesten er ikke rettet mot personer under 18 år. Vi samler ikke bevisst 
            inn informasjon fra mindreårige.
          </p>

          <h2>10. Endringer</h2>
          <p>
            Vi kan oppdatere denne erklæringen. Vesentlige endringer varsles via 
            e-post eller på nettsiden.
          </p>

          <h2>11. Kontakt</h2>
          <p>
            For spørsmål om personvern eller for å utøve dine rettigheter, kontakt oss på:
          </p>
          <p>
            <strong>E-post:</strong> personvern@golfmarked.no
          </p>

          <div className="mt-8 p-4 bg-gray-100 rounded-lg">
            <p className="text-sm text-gray-600">
              Ved å bruke GolfMarked godtar du denne personvernerklæringen.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
